/**
 * 无激活页时的工作区属性面板。
 */
import { useCanvas } from '@/components/canvas/designer/shell/CanvasContext';

export function WorkspaceProperties() {
  const { pages, workspaceElements } = useCanvas();
  const hasPages = pages.length > 0;

  return (
    <div className="property-panel-view min-h-0 w-full shrink-0 space-y-4 p-4 text-sm">
      <p className="font-medium text-default-foreground">工作区</p>
      <p className="leading-relaxed text-muted-foreground">
        当前无激活页面。点击页面板面或标题栏 P&#123;n&#125; 可激活页面；点击工作区空白可保持本状态。
      </p>
      <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-2 text-muted-foreground">
        <dt>页面数</dt>
        <dd className="tabular-nums text-default-foreground">{pages.length}</dd>
        <dt>工作区元素</dt>
        <dd className="tabular-nums text-default-foreground">{workspaceElements.length}</dd>
      </dl>
      {!hasPages ? (
        <p className="text-xs text-muted-foreground">
          文档中尚无页面时，可通过缩略图栏或页面菜单添加第一页；新页默认落在世界坐标原点 (0, 0)。
        </p>
      ) : null}
      <p className="text-xs text-muted-foreground">
        在本状态下插入的元素会加入工作区（世界坐标），默认落在当前视口中心。
      </p>
    </div>
  );
}
